import { render, staticRenderFns } from "./StandardGrid.vue?vue&type=template&id=006bee10&scoped=true&"
import script from "./StandardGrid.vue?vue&type=script&lang=js&"
export * from "./StandardGrid.vue?vue&type=script&lang=js&"
import style0 from "./StandardGrid.vue?vue&type=style&index=0&id=006bee10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006bee10",
  null
  
)

export default component.exports